"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.borrowerDetailsExtendedSchema = void 0;
var borrower_details_schema_1 = require("./borrower-details-schema");
var constants_1 = require("../../constants");
exports.borrowerDetailsExtendedSchema = __assign(__assign({}, borrower_details_schema_1.borrowerDetailsSchema), { allOf: [
        {
            if: {
                properties: {
                    defaultReasonCode: {
                        const: constants_1.DefaultReason.Other,
                    },
                },
            },
            then: {
                required: ['otherDefaultReasonDescription'],
                properties: {
                    otherDefaultReasonDescription: {
                        type: 'string',
                        minLength: 1,
                        maxLength: 100,
                    },
                },
            },
            else: {
                properties: {
                    otherDefaultReasonDescription: {
                        type: 'null',
                    },
                },
            },
        },
        {
            if: {
                properties: {
                    judgmentActionTypeCode: {
                        const: constants_1.JudgmentAction.NotPursued,
                    },
                },
            },
            then: {
                required: ['reasonNotPursuedTypeCode'],
                properties: {
                    reasonNotPursuedTypeCode: {
                        enum: Object.values(constants_1.ReasonNotPursued),
                    },
                },
                if: {
                    properties: {
                        reasonNotPursuedTypeCode: {
                            const: constants_1.ReasonNotPursued.Other,
                        },
                    },
                },
                then: {
                    required: ['otherReasonNotPursuedDescription'],
                    properties: {
                        otherReasonNotPursuedDescription: {
                            type: 'string',
                            minLength: 1,
                            maxLength: 100,
                        },
                    },
                },
                else: {
                    properties: {
                        otherReasonNotPursuedDescription: {
                            type: 'null',
                        },
                    },
                },
            },
            else: {
                properties: {
                    reasonNotPursuedTypeCode: {
                        type: 'null',
                    },
                    otherReasonNotPursuedDescription: {
                        type: 'null',
                    },
                },
            },
        },
    ] });
